(function () {
  if (customElements.get('card-quick-add')) return;

  var COLOR_FALLBACKS = {
    preto: '#111111',
    black: '#111111',
    branco: '#ffffff',
    white: '#ffffff',
    vermelho: '#c0392b',
    red: '#c0392b',
    azul: '#2c5aa0',
    blue: '#2c5aa0',
    verde: '#2e7d32',
    green: '#2e7d32',
    amarelo: '#f1c40f',
    yellow: '#f1c40f',
    rosa: '#e91e8c',
    pink: '#e91e8c',
    cinza: '#9e9e9e',
    grey: '#9e9e9e',
    gray: '#9e9e9e',
    marrom: '#6d4c41',
    brown: '#6d4c41',
    bege: '#d8c3a5',
    beige: '#d8c3a5',
    laranja: '#e67e22',
    orange: '#e67e22',
    roxo: '#7b1fa2',
    purple: '#7b1fa2',
    dourado: '#c9a227',
    gold: '#c9a227',
    prata: '#c0c0c0',
    silver: '#c0c0c0',
    nude: '#e0c3b0',
    offwhite: '#f5f5f0',
    'off-white': '#f5f5f0',
  };

  function optionsMatch(variantOptions, selected) {
    return variantOptions.every(function (opt, index) {
      return selected[index] == null || selected[index] === '' || opt === selected[index];
    });
  }

  class CardQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      var jsonNode = this.querySelector('[data-card-variants]');
      try {
        this.variants = jsonNode ? JSON.parse(jsonNode.textContent) : [];
      } catch (error) {
        this.variants = [];
      }

      this.idInput = this.querySelector('[name="id"]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitLabel = this.querySelector('[data-card-quick-add-label]');
      this.colorIndex = this.dataset.colorIndex === '' ? null : Number(this.dataset.colorIndex);

      this.applyColorFallbacks();
      this.addEventListener('change', this.onOptionChange.bind(this));
      this.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      this.selectAvailableVariant();
      this.updateState();
    }

    selectAvailableVariant() {
      var selected = this.getSelectedOptions();
      var variant = this.findVariant(selected);
      if (variant && variant.available) return;

      var fallback = this.findAvailableVariant(selected, this.colorIndex);
      if (fallback) this.selectOptions(fallback.options);
    }

    applyColorFallbacks() {
      this.querySelectorAll('[data-color-name]').forEach(function (input) {
        var label = input.nextElementSibling;
        if (!label || !label.classList.contains('card-quick-add__swatch')) return;
        if (label.style.backgroundColor || label.style.backgroundImage) return;
        var key = (input.dataset.colorName || '').toLowerCase().trim();
        if (COLOR_FALLBACKS[key]) {
          label.style.backgroundColor = COLOR_FALLBACKS[key];
          label.classList.remove('card-quick-add__swatch--named');
          label.textContent = '';
        }
      });
    }

    getSelectedOptions() {
      var selected = [];
      this.querySelectorAll('fieldset[data-option-index]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        selected[Number(fieldset.dataset.optionIndex)] = checked ? checked.value : null;
      });
      return selected;
    }

    findVariant(selected) {
      return this.variants.find(function (variant) {
        return optionsMatch(variant.options, selected);
      });
    }

    findAvailableVariant(selected, requiredIndex) {
      return this.variants.find(function (variant) {
        if (!variant.available) return false;
        if (requiredIndex == null) return true;
        return variant.options[requiredIndex] === selected[requiredIndex];
      });
    }

    onOptionChange(event) {
      var changedFieldset = event.target.closest('fieldset[data-option-index]');
      var changedIndex = changedFieldset ? Number(changedFieldset.dataset.optionIndex) : null;
      var selected = this.getSelectedOptions();
      var variant = this.findVariant(selected);
      var changedColor = this.colorIndex != null && changedIndex === this.colorIndex;

      if ((!variant || !variant.available) && changedColor) {
        var fallback = this.findAvailableVariant(selected, this.colorIndex);
        if (fallback) this.selectOptions(fallback.options);
      }

      this.updateState();
    }

    selectOptions(options) {
      this.querySelectorAll('fieldset[data-option-index]').forEach(function (fieldset) {
        var index = Number(fieldset.dataset.optionIndex);
        var escaped = options[index] == null ? '' : String(options[index]);
        var selector = 'input[type="radio"][value="' + escaped.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]';
        var input = fieldset.querySelector(selector);
        if (input) input.checked = true;
      });
    }

    updateState() {
      var selected = this.getSelectedOptions();
      var variant = this.findVariant(selected);
      var self = this;

      this.querySelectorAll('fieldset[data-option-index]').forEach(function (fieldset) {
        var index = Number(fieldset.dataset.optionIndex);
        fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var trial = selected.slice();
          trial[index] = input.value;
          var isColorOption = self.colorIndex != null && index === self.colorIndex;
          var availableMatch = self.variants.find(function (item) {
            if (!item.available) return false;
            if (isColorOption) return item.options[index] === input.value;
            return optionsMatch(item.options, trial);
          });
          input.classList.toggle('is-unavailable', !availableMatch);
        });
      });

      if (this.idInput) {
        if (variant) {
          this.idInput.value = String(variant.id);
          this.idInput.disabled = !variant.available;
        } else {
          this.idInput.disabled = true;
        }
      }

      if (this.submitButton) {
        this.submitButton.disabled = !variant || !variant.available;
      }

      if (this.submitLabel) {
        this.submitLabel.textContent =
          !variant || !variant.available ? this.dataset.soldOutLabel : this.dataset.addLabel;
      }

      this.updateImage(variant);
    }

    updateImage(variant) {
      if (!variant || !variant.featured_image) return;
      var card = this.closest('.card-wrapper');
      if (!card) return;
      var image = card.querySelector('.card__media img');
      if (!image) return;
      image.src = variant.featured_image;
      image.removeAttribute('srcset');
    }
  }

  customElements.define('card-quick-add', CardQuickAdd);
})();
